import React from 'react';
import AboutSection from '../components/about/index';
import {Heading3} from '../typography/typography';
import Fade from 'react-reveal/Fade';


export default function AboutContainer() {
    return (
        <AboutSection id="about">
            <Heading3>ABOUT ME</Heading3>
            <AboutSection.MainContainer>
            
                <AboutSection.ContentContainer>
                    <Fade>
                        <AboutSection.Image src="/images/about.jpg" />
                    </Fade>
                </AboutSection.ContentContainer>
            
                <AboutSection.ContentContainer textContainer>
                    <AboutSection.Text>
                    <Fade right>
                        <AboutSection.Span>
                            <em>
                                Exploring new things specially related to my field and
                                using it for the betterment of my personality and community 
                                make me content. I am an excellent self-learner, consistent 
                                with my work, and adaptive to the work and environment.
                            </em>
                        </AboutSection.Span>
                        </Fade>
                        <Fade right>
                        <AboutSection.Span>
                            <em>
                                My objectives include; first, to develop skills 
                                and apply those in professional life to get tasks done efficiently. 
                                Second, to use these skills as a base to solve problems in society 
                                and industry, and boost innovation. Third, to use these skills and 
                                academia to aid my respective field in my country.
                            </em>
                        </AboutSection.Span> 
                        </Fade>
                        <Fade right>
                        <AboutSection.Span>
                            <em>
                                I want to expand my knowledge in Web Development and Artificial 
                                Intelligence to make systems more presentable and efficient. 
                            </em>
                        </AboutSection.Span>
                        </Fade>
                    </AboutSection.Text>
                </AboutSection.ContentContainer>
            </AboutSection.MainContainer>
        </AboutSection>
    )
}